import {useEffect, useState} from "react";
import {AnimatedStatusType} from "./types";

export const useAnimatedStatus = (status: AnimatedStatusType) => {
    const [activeStatus, setActiveStatus] = useState<AnimatedStatusType>(status);

    useEffect(() => {
        setActiveStatus(status);
        if (status === "success" || status === "error") {
            const timer = setTimeout(() => setActiveStatus("idle"), 4000);
            return () => clearTimeout(timer);
        }
    }, [status]);

    return {activeStatus, setActiveStatus};
}